module.exports = __webpack_public_path__ + "img/bottom-list6.63de4d41.png";